import React, { useState, useEffect, useCallback } from 'react';
import { InputText } from 'components/common/input';
import BaseModalForm from 'components/common/modal/BaseModalForm';
import { useFormHandlers } from 'core/hooks/form/formHandlers';
import { Alert } from 'react-bootstrap';
import { MODAL_FORM_ERRORS } from 'core/constant/MODAL_FORM_ERRORS';

const EditProductHelpModal = ({ show, productHelp, handleClose, handleSave, updating, errors, requestError }) => {
  const [formValues, setFormValues] = useState(productHelp);
  const { handleChange } = useFormHandlers(setFormValues);

  useEffect(() => {
    setFormValues(productHelp);
  }, [productHelp]);

  const handleSaveClick = useCallback(() => {
    handleSave({ ...formValues, id: productHelp?.id });
  }, [formValues, productHelp?.id, handleSave]);

  return (
    <BaseModalForm show={show} title={productHelp?.id ? "Editar Videos de Ayuda" : "Crear Videos de Ayuda"} handleClose={handleClose} handleSave={handleSaveClick} updating={updating}>
      <div className="row">
        <div className="col-md-6 form-group">
          <InputText
            label="Título"
            name="title"
            value={formValues?.title}
            onChange={(e) => handleChange('title', e.target.value)}
            placeholder="Ingrese el título"
            error={errors.title}
          />
        </div>
        <div className="col-md-6 form-group">
          <InputText
            label="ID del Video"
            name="video_id"
            value={formValues?.video_id}
            onChange={(e) => handleChange('video_id', e.target.value)}
            placeholder="Ingrese el ID del video"
            error={errors.video_id}
          />
        </div>
        <div className="col-md-12 form-group">
          <InputText
            label="Descripción"
            name="description"
            value={formValues?.description}
            onChange={(e) => handleChange('description', e.target.value)}
            placeholder="Ingrese la descripción"
            error={errors.description}
          />
        </div>
        <div className="col-12 form-group mt-3">
          {requestError &&
            <Alert variant="danger">
              {requestError?.response?.data?.message ||
               MODAL_FORM_ERRORS.PRODUCT_HELP}
            </Alert>
          }
        </div>
      </div>
    </BaseModalForm>
  );
};

export default React.memo(EditProductHelpModal);
